import CategoryManage from "./create-shift-category";

export default CategoryManage;
